<app-tdo-progress-spinner *ngIf="isLoading === true" data-cy="insurance-management-loading"></app-tdo-progress-spinner>
<div *ngIf="isLoading === false" class="insurance-management-main" data-cy="insurance-management-main">
  <div class="insurance-management-content" data-cy="insurance-management-content">
<!--    CARRIERS-->
    <div style="display: flex; flex-direction: column; flex: 1; max-width: 550px" data-cy="insurance-management-carriers-container">
      <div class="section" style="margin-right: 4px; flex-basis: fit-content;" data-cy="insurance-management-carrier-section">
        <div class="section-header" data-cy="insurance-management-carrier-header">
          <div *ngIf="!globals.validTDOXpatientID" class="section-header-title" data-cy="insurance-management-carrier-title">
            {{ globals.currentPatientFullName + ' - '}} Carrier Profiles
          </div>
          <div matTooltip="You do not have access to edit this page." style="padding: 6px 8px 0 8px; font-weight: normal; color: yellow; text-align: right; display: flex;" *ngIf="!isElementEnabled()" data-cy="insurance-management-view-only-mode"><div style="position: relative; top: 0;">View Only Mode</div> <div style="position: relative; top: -2px; margin-left: 2px;"><mat-icon>help_outline</mat-icon></div></div>
          <div class="section-header-buttons" data-cy="insurance-management-carrier-buttons">
            <div [matTooltip]="this.hideExpired ? 'Show All' : 'Hide Expired and Deleted'" (click)="hideShowNotActive()" data-cy="insurance-management-toggle-expired">
              <mat-icon *ngIf="!this.hideExpired" data-cy="insurance-management-show-icon">visibility</mat-icon>
              <mat-icon *ngIf="this.hideExpired" data-cy="insurance-management-hide-icon">visibility_off</mat-icon>
            </div>
            <div matTooltip="Delete Selected Carrier" (click)="removeSelectedCarrier()" *ngIf="!this.disablePage() && isElementEnabled()" data-cy="insurance-management-delete-carrier"><mat-icon>delete</mat-icon></div>
            <div *ngIf="isElementEnabled()" style="margin-right: 8px;" matTooltip="Add Carrier" (click)="launchCarrierManager()" data-cy="insurance-management-add-carrier"><mat-icon>add_circle_outline</mat-icon></div>
          </div>
        </div>
        <div class="section-content" data-cy="insurance-management-carrier-content">
          <div class="carrier-list" data-cy="insurance-management-carrier-list">
            <div *ngIf="!isLoading" data-cy="insurance-management-carrier-list-container">
              <div *ngIf="!this.dataPatientInsuranceList?.length" class="no-carrier-found" data-cy="insurance-management-no-carriers">
                No carriers found for this patient.
              </div>

              <div *ngFor="let insurance of dataPatientInsuranceList; let i = index" class="carrier-item"
                   [class.expired-item]="false"
                   [class.hide-expired]="insurance.hideRow"
                   [class.carrier-item-active]="selectedRow == i"
                   (click)="setActiveDataPatientInsurance(insurance, i)"
                   data-cy="insurance-management-carrier-item-{{i}}">

                <div class="carrier-name" data-cy="insurance-management-carrier-name-{{i}}">
                  {{ insurance.Description }} {{ isInsuranceExpired(insurance)  ? ' (Expired)' : '' }} {{ !insurance.isActive ? ' (Not Active)' : '' }}
                </div>
              </div>
            </div>
            <div *ngIf="isLoading" class="loading-spinner" data-cy="insurance-management-carrier-loading">
              <mat-spinner [diameter]="50" data-cy="insurance-management-carrier-spinner"></mat-spinner>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="activeDataPatientInsuranceVisibleCount > 1" class="section" style="margin-right: 4px; flex: 1; margin-top: 4px; height: 100%;" data-cy="insurance-management-details-section">
        <div class="section-header" data-cy="insurance-management-details-header">
          <div class="section-header-title" data-cy="insurance-management-details-title">
            Carrier Details {{ activeDataPatientInsurance ? ' - Fee Schedule: ' + activeDataPatientInsurance.FeeScheduleName : '' }}
          </div>
          <div class="section-header-buttons" data-cy="insurance-management-details-buttons"></div>
        </div>
        <div class="section-content" style="display: flex; flex-direction: column; height: 100%;" data-cy="insurance-management-details-content">
          <div class="carrier-details" style="padding-left: 0;" *ngIf="activeDataPatientInsurance" data-cy="insurance-management-carrier-details">
            <table style="width:100%" data-cy="insurance-management-details-table">
              <tr data-cy="insurance-management-employer-row">
                <td style="width: 80%; max-width: 300px;" data-cy="insurance-management-employer-cell">
                  <b data-cy="insurance-management-employer-label">Employer:</b> <span data-cy="insurance-management-employer-value">{{ activeDataPatientInsurance.EmployerNO }}</span>
                  <b data-cy="insurance-management-group-label">Group:</b> <span data-cy="insurance-management-group-value">{{  activeDataPatientInsurance.GroupNO  }}</span>
                </td>
                <td style="width: 20%;" data-cy="insurance-management-empty-cell-1">
                </td>
              </tr>
              <tr data-cy="insurance-management-profile-row">
                <td style="width: 80%; max-width: 300px;" data-cy="insurance-management-profile-cell">
                  <b data-cy="insurance-management-profile-label">Profile:</b> <span data-cy="insurance-management-profile-value">{{activeDataPatientInsurance.Description}}</span>
                </td>
                <td style="width: 20%;" data-cy="insurance-management-profile-button-cell">
                  <button class="tdo-button tdo-save" style="width: 100px;" (click)="launchInsuranceProfileSettings()" data-cy="insurance-management-profile-button">Profile</button>
                </td>
              </tr>
              <tr data-cy="insurance-management-payer-row">
                <td style="width: 80%; " data-cy="insurance-management-payer-cell">
                  <b data-cy="insurance-management-payer-label">Payer:</b> <span data-cy="insurance-management-payer-value">{{activeDataPatientInsurance.PayerOragnization}} -
                  NEIC: {{activeDataPatientInsurance.PayerIDperNEIC}}</span>
                </td>
                <td style="width: 20%;" data-cy="insurance-management-empty-cell-2">
                </td>
              </tr>
              <tr *ngIf="activeDataPatientInsurance.patient_DocFeeScheduleID!=null" data-cy="insurance-management-fsow-row">
                  <td style="width: 80%; " data-cy="insurance-management-fsow-cell">
                    <h5 matTooltip="Fee Schedule Overwrite" data-cy="insurance-management-fsow-value">FSOW: {{activeDataPatientInsurance.patient_DocFeeScheduleDescription}}</h5>
                  </td>
                  <td style="width: 20%;" data-cy="insurance-management-fsow-button-cell">
                    <button class="tdo-button tdo-save" style="width: 100px;" (click)="onClickClearPatientFeeSched()" matTooltip="Clear Fee Schedule Overwrite" data-cy="insurance-management-fsow-clear-button">Clear</button>
                  </td>
              </tr>
            </table>
            <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;" data-cy="insurance-management-divider-1">
            <div class="coverage-header" style="padding-top: 2px" data-cy="insurance-management-subscriber-header">
              <h5 class="inline-header" style="color: var(--tdo-primary);" data-cy="insurance-management-subscriber-title">Subscriber</h5>
              <div class="inline-header-buttons" data-cy="insurance-management-subscriber-buttons">
                <div matTooltip="Edit Subscriber" (click)="launchSubscriberManager()" style="cursor: pointer;"
                     *ngIf="!this.disablePage() && isElementEnabled()" data-cy="insurance-management-subscriber-select-container">
                  <button class="tdo-button tdo-save" style="width: 100px;" data-cy="insurance-management-subscriber-select-button">Select</button>
                </div>
              </div>
            </div>

            <div class="subscriber-details"
                 *ngIf="!activeDataPatientInsurance.SubsciberContactId"
                 data-cy="insurance-management-no-subscriber">
              Please choose a subscriber
            </div>

            <div class="subscriber-details"
                 *ngIf="activeDataPatientInsurance.SubscriberContact
             && activeDataPatientInsurance.enumInsuranceRelationId === '00000045-1000-0000-0000-000000000001'"
                 data-cy="insurance-management-self-subscriber">
              SELF - Patient is the insurance subscriber
            </div>

            <div class="subscriber-details" *ngIf="activeDataPatientInsurance.SubscriberContact && activeDataPatientInsurance.enumInsuranceRelationId !== '00000045-1000-0000-0000-000000000001'" data-cy="insurance-management-other-subscriber">
              <!-- have the form but disable the input fields if there is not subscriber. still allow to pick a subscriber -->

              <div class="carrier-name" data-cy="insurance-management-subscriber-name-container">
                <div class="detail-header" data-cy="insurance-management-subscriber-name-label">Name:</div>
                <div class="detail-input" *ngIf="activeDataPatientInsurance.SubscriberContact" data-cy="insurance-management-subscriber-name-value">
                  <div data-cy="insurance-management-subscriber-name">
                    {{ activeDataPatientInsurance.SubscriberContact.FirstName }}
                    {{ activeDataPatientInsurance.SubscriberContact.LastName }}
                  </div>
                </div>
              </div>

              <div style="display: flex; flex-direction: row" class="subscriber-relation input-container-height" data-cy="insurance-management-relation-container">
                <div style="flex: 1" data-cy="insurance-management-relation-dropdown">
                  <app-tdo-enum-select placeholder="Patient's Relationship to Subscriber" placeholderPosition="above"
                                       name="enumInsuranceRelation" [validValueItemId]="activeDataPatientInsurance.enumInsuranceRelationId"
                                       (enumSelected)="activeDataPatientInsurance.enumInsuranceRelationId = $event?.ValidValueItemId;saveDataPatientInsurance(activeDataPatientInsurance)"
                                       data-cy="insurance-management-relation-select"></app-tdo-enum-select>
                  <a *ngIf="isDentalExchangeConfiguredForLocation" href="javascript: void(0);" (click)="launchDentalExchangeXRef()" data-cy="insurance-management-dental-xref">DentalXchange X reference</a>
<!--                  <app-tdo-enum-select placeholder="Relationship to Patient" placeholderPosition="above" *ngIf="!isDentalExchangeConfiguredForLocation"-->
<!--                  name="enumInsuranceRelation" [validValueItemId]="activeDataPatientInsurance.enumInsuranceRelationId"-->
<!--                  (enumSelected)="activeDataPatientInsurance.enumInsuranceRelationId = $event?.ValidValueItemId;saveDataPatientInsurance(activeDataPatientInsurance)"></app-tdo-enum-select>-->
                </div>
                <div style="flex: 1" data-cy="insurance-management-dob-container">
                  <mat-form-field class="subscriber-dob" data-cy="insurance-management-dob-field">
                    <mat-label data-cy="insurance-management-dob-label">Subscriber DOB</mat-label>
                    <input matInput [matDatepicker]="subDOBPicker"
                           [disabled]="this.disablePage() || !isElementEnabled()"
                           (dateChange)="saveSubscriberContact(activeDataPatientInsurance.SubscriberContact)"
                           [(ngModel)]="activeDataPatientInsurance.SubscriberContact.BirthDate"
                           autocomplete="off"
                           data-cy="insurance-management-dob-input"/>
                    <mat-datepicker-toggle matSuffix [for]="subDOBPicker" data-cy="insurance-management-dob-toggle"></mat-datepicker-toggle>
                    <mat-datepicker #subDOBPicker data-cy="insurance-management-dob-picker"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="coverage-header" data-cy="insurance-management-coverage-header">
              <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;" data-cy="insurance-management-divider-2">
              <p style="color: var(--tdo-primary);" data-cy="insurance-management-coverage-title">Coverage Details</p>
            </div>

            <div class="coverage-dates-container input-container-height" data-cy="insurance-management-coverage-dates">
              <mat-form-field class="coverage-date-form coverage-date-right" data-cy="insurance-management-start-field">
                <mat-label data-cy="insurance-management-start-label">Start</mat-label>
                <input matInput [matDatepicker]="startPicker" data-cy="insurance-coverage-start-date"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       (dateChange)="saveDataPatientInsurance(activeDataPatientInsurance)"
                       [(ngModel)]="activeDataPatientInsurance.CoverageStart"
                       autocomplete="off"
                       data-cy="insurance-management-start-input"/>
                <mat-datepicker-toggle matSuffix [for]="startPicker" data-cy="insurance-management-start-toggle"></mat-datepicker-toggle>
                <mat-datepicker #startPicker data-cy="insurance-management-start-picker"></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="coverage-date-form" data-cy="insurance-management-end-field">
                <mat-label data-cy="insurance-management-end-label">End</mat-label>
                <input matInput [matDatepicker]="endPicker" data-cy="insurance-coverage-end-date"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       (dateChange)="saveDataPatientInsurance(activeDataPatientInsurance)"
                       [(ngModel)]="activeDataPatientInsurance.CoverageEnd"
                       autocomplete="off"
                       data-cy="insurance-management-end-input"/>
                <mat-datepicker-toggle matSuffix [for]="endPicker" data-cy="insurance-management-end-toggle"></mat-datepicker-toggle>
                <mat-datepicker #endPicker data-cy="insurance-management-end-picker"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="insurance-number-container input-container-height" data-cy="insurance-management-number-container">
              <mat-form-field data-cy="insurance-management-subscriber-id-field">
                <mat-label data-cy="insurance-management-subscriber-id-label">Subscriber ID #</mat-label>
                <input matInput data-cy="insurance-coverage-subscriber-id"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                       [(ngModel)]="activeDataPatientInsurance.PatientInsuranceNO"
                       autocomplete="off"
                       data-cy="insurance-management-subscriber-id-input"/>
              </mat-form-field>
            </div>

            <div class="coverage-primary-status" data-cy="insurance-management-status-container">
              <div class="detail-header" data-cy="insurance-management-status-label"><span style="color: var(--tdo-primary);">Insurance Status:</span></div>
              <div class="detail-input" style="position: relative; top: 2px;" data-cy="insurance-management-status-options">
                <mat-radio-group aria-label="Select an option"
                                 [disabled]="dataPatientInsuranceList?.length <= 1 || !isElementEnabled()"
                                 (change)="changePrimaryInsurance($event)"
                                 [(ngModel)]="activeDataPatientInsurancePrimary"
                                 data-cy="insurance-management-status-radio">
                  <mat-radio-button class="insurance-status-option" value="primary" data-cy="insurance-management-primary-radio">Primary</mat-radio-button>
                  <mat-radio-button class="insurance-status-option" value="secondary" data-cy="insurance-management-secondary-radio">Secondary</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="activeDataPatientInsuranceVisibleCount > 1" class="section" style="margin-left: 4px; flex: 1;" data-cy="insurance-management-benefits-section">
      <div class="section-header" data-cy="insurance-management-benefits-header">
        <div class="section-header-title" data-cy="insurance-management-benefits-title">
          Benefits - With<span *ngIf="!cfgTDOClient?.ARisEstimating" data-cy="insurance-management-benefits-no-est"> No</span> Insurance Estimation
        </div>
        <div class="section-header-buttons" data-cy="insurance-management-benefits-buttons">
        </div>
      </div>
      <div class="section-content" style="display: flex; flex-direction: column; height: 100%;" data-cy="insurance-management-benefits-content">
        <div style="margin-left: 10px;" class="input-container-height" data-cy="insurance-management-no-insurance-container">
          <mat-checkbox #insuranceYesNo
                        class="insurance-yes-no"
                        [checked]="patientHasNoInsurance"
                        type="checkbox"
                        (change)="savePatientHasInsurance($event.checked)"
                        data-cy="insurance-management-no-insurance-checkbox">
            Patient Has No Insurance
          </mat-checkbox>
        </div>
        <div *ngIf="activeDataPatientInsurance" data-cy="insurance-management-benefits-details">
          <div style="display: flex;" data-cy="insurance-management-changed-date-container">
            <div class="changed-date input-container-height" style="flex: 1;" data-cy="insurance-management-changed-date-field-container">
              <mat-form-field style="width: 100%;" class="changed-date" data-cy="insurance-management-changed-date-field">
                <mat-label data-cy="insurance-management-changed-date-label">Changed date</mat-label>
                <input matInput [matDatepicker]="changedDatePicker"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       (dateChange)="saveDataPatientInsurance(activeDataPatientInsurance)"
                       [(ngModel)]="activeDataPatientInsurance.BenefitsChangedOn"
                       autocomplete="off"
                       data-cy="insurance-management-changed-date-input">
                <mat-datepicker-toggle matSuffix [for]="changedDatePicker" data-cy="insurance-management-changed-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #changedDatePicker data-cy="insurance-management-changed-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="duplication-checkbox input-container-height" style="flex: 1; color: var(--tdo-primary);" data-cy="insurance-management-duplication-container">
              <mat-checkbox style="position: relative; margin-left: 24px;"
                [disabled]="this.disablePage() || !isElementEnabled()"
                (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                [(ngModel)]="activeDataPatientInsurance.BenefitsNonDuplication"
                data-cy="insurance-management-duplication-checkbox">Non-Duplication of Benefits Clause</mat-checkbox>
            </div>
          </div>

          <div style="display: flex;" data-cy="insurance-management-benefits-amount-container">
            <div class="benefits-amount-input input-container-height" style="flex: 1;" data-cy="insurance-management-max-benefits-container">
              <mat-form-field style="width: 100%;" class="max-benefits" data-cy="insurance-management-max-benefits-field">
                <mat-label data-cy="insurance-management-max-benefits-label">Max Benefits</mat-label>
                <input matInput data-cy="insurance-coverage-benefits-maximum"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsMaximum | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsMaximum')"
                       autocomplete="off"
                       data-cy="insurance-management-max-benefits-input"
                />
              </mat-form-field>
            </div>

            <div class="benefits-amount-input input-container-height" style="flex: 1;" data-cy="insurance-management-benefits-left-container">
              <mat-form-field style="width: 100%;" class="max-benefits" data-cy="insurance-management-benefits-left-field">
                <mat-label data-cy="insurance-management-benefits-left-label">Benefits left</mat-label>
                <input matInput data-cy="insurance-coverage-benefits-left"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsLeft | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsLeft')"
                       autocomplete="off"
                       data-cy="insurance-management-benefits-left-input"
                />
              </mat-form-field>
            </div>

            <div class="benefits-amount-input" style="flex-basis: fit-content;" data-cy="insurance-management-rtb-container">
              <button class="tdo-button tdo-save"
                      [disabled]="this.disablePage() || !isElementEnabled() || !this.isDentalExchangeConfiguredForLocation"
                      (click)="launchRTBResponseViewer()"
                      data-cy="insurance-management-rtb-button">RTB</button>

            </div>
          </div>

          <div class="deductables-amount"  *ngIf="!cfgTDOClient?.ARisEstimating">
            <div style="line-height: 0.2;">
              <h5 style="color: var(--tdo-primary);">Deductible Left</h5>
              <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;">
            </div>

            <div style="margin-top: 12px;" class="input-container-height">
              <mat-form-field class="max-benefits">
                <mat-label>Deductible Amount Left</mat-label>
                <input matInput data-cy="insurance-coverage-deductible-left"
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsDeductibleLeft | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsDeductibleLeft')"
                       autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="input-container-height" style="flex: 1; color: var(--tdo-primary);">
              <mat-checkbox style="position: relative; margin-left: 24px;"
                [disabled]="this.disablePage() || !isElementEnabled()"
                (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                [(ngModel)]="activeDataPatientInsurance.isBenefitsPreventative">Treatment Category A</mat-checkbox>
            </div>

            <div class="input-container-height" style="flex: 1; color: var(--tdo-primary);">
              <mat-checkbox style="position: relative; margin-left: 24px;"
                [disabled]="this.disablePage() || !isElementEnabled()"
                (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                [(ngModel)]="activeDataPatientInsurance.isBenefitsStandard">Treatment Category B</mat-checkbox>
            </div>

            <div class="input-container-height" style="flex: 1; color: var(--tdo-primary);">
              <mat-checkbox style="position: relative; margin-left: 24px;"
                [disabled]="this.disablePage() || !isElementEnabled()"
                (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                [(ngModel)]="activeDataPatientInsurance.isBenefitsOther">Treatment Category C</mat-checkbox>
            </div>

            <div style="line-height: 0.2; margin-top: 12px">
              <h5 style="color: var(--tdo-primary);">Coverage</h5>
              <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;">
            </div>

            <div class="coverage-percent-container" >
              <div class="coverage-percent-container-title input-container-height">
                <mat-form-field class="coverage-percent-container-textbox">
                  <mat-label>Preventative (A)</mat-label>
                  <input matInput data-cy="insurance-coverage-deductible-preventative"
                         [disabled]="this.disablePage() || !isElementEnabled()"
                         placeholder="Preventative (A)"
                         [(ngModel)]="activeDataPatientInsurance.CoveragePreventitive"
                         (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                         autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="no-padding">%</div>
              <div class="input-container-height">
                <mat-form-field class="coverage-percent-container-textbox">
                  <mat-label>Standard (B)</mat-label>
                  <input matInput data-cy="insurance-coverage-deductible-standard"
                         [disabled]="this.disablePage() || !isElementEnabled()"
                         placeholder="Standard (B)"
                         [(ngModel)]="activeDataPatientInsurance.CoverageStandard"
                         (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                         autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="no-padding">%</div>
              <div class="input-container-height">
                <mat-form-field class="coverage-percent-container-textbox">
                  <mat-label>Other (C)</mat-label>
                  <input matInput data-cy="insurance-coverage-deductible-other"
                         [disabled]="this.disablePage() || !isElementEnabled()"
                         placeholder="Other (C)"
                         [(ngModel)]="activeDataPatientInsurance.CoverageOther"
                         (change)="saveDataPatientInsurance(activeDataPatientInsurance)"
                         autocomplete="off"
                  />
                </mat-form-field>
              </div>
              <div class="no-padding">%</div>
            </div>
          </div>



          <div class="deductables-amount"  *ngIf="cfgTDOClient?.ARisEstimating">
            <div style="line-height: 0.2;">
              <h5 style="color: var(--tdo-primary);">Deductible Left</h5>
              <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;">
            </div>
            <div style="margin-top: 12px;" class="input-container-height">
              <mat-form-field class="max-benefits">
                <mat-label>Preventative (A)</mat-label>
                <input matInput
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsDeductableLeftPreventitive | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsDeductableLeftPreventitive')"
                       autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="input-container-height">
              <mat-form-field class="max-benefits">
                <mat-label>Standard (B)</mat-label>
                <input matInput
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsDeductableLeftStandard | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsDeductableLeftStandard')"
                       autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="input-container-height">
              <mat-form-field class="max-benefits">
                <mat-label>Other (C)</mat-label>
                <input matInput
                       [disabled]="this.disablePage() || !isElementEnabled()"
                       [value]="activeDataPatientInsurance.BenefitsDeductableLeftOther | currency:'USD':'symbol'"
                       (change)="saveCurrencyField($event, 'BenefitsDeductableLeftOther')"
                       autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div style="line-height: 0.2; margin-top: 12px">
              <h5 style="color: var(--tdo-primary);">Coverage Amounts</h5>
              <hr style="background-color: var(--tdo-primary); line-height: 0.1; opacity: 0.4; margin-top: 0; margin-bottom: 0;">
            </div>

            <div *ngIf="dataPatientInsuranceList?.length">

              <div class="insurance-management-benefits-buttons">
                <button class="tdo-button tdo-save"
                        [disabled]="!activeDataPatientInsurance || this.disablePage() || !isElementEnabled()"
                        (click)="launchCoverageManager()">Coverage Table</button>

                <button class="tdo-button tdo-save"
                        *ngIf="activeDataPatientInsurance && activeDataPatientInsurance.CoverageEnd < defaultDate"
                        (click)="markInsuranceAsActive()"
                        [disabled]="!activeDataPatientInsurance || this.disablePage() || !isElementEnabled()">
                  Mark as active
                </button>

                <button class="tdo-button tdo-close"
                        *ngIf="activeDataPatientInsurance && activeDataPatientInsurance.CoverageEnd > defaultDate"
                        (click)="markInsuranceAsExpired()"
                        [disabled]="!activeDataPatientInsurance || this.disablePage() || !isElementEnabled()">
                  Mark as Expired
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="activeDataPatientInsuranceVisibleCount <= 1" style="display: flex; flex-direction: column; width: 500px; text-align: center; padding-top: 200px" data-cy="insurance-management-add-new-container">
      <div data-cy="insurance-management-add-new">
        <div style="flex: 1" data-cy="insurance-management-add-new-button-container">
          <div style="margin-right: 8px; cursor: pointer; font-size: 20px" matTooltip="Add Carrier" data-cy="insurance-add-carrier" (click)="launchCarrierManager()"><mat-icon>add_circle_outline</mat-icon> Add New Insurance Carrier</div>
        </div>
      </div>
    </div>
  </div>
  <div class="insurance-management-summary" style="display: flex; width: 100%; margin-top: 4px;" data-cy="insurance-management-summary">
    <div class="section" style="flex: 1;" data-cy="insurance-management-claims-section">
      <div class="section-header" data-cy="insurance-management-claims-header">
        <div class="section-header-title" data-cy="insurance-management-claims-title">
          Summary of Claims
        </div>
        <div class="section-header-buttons" data-cy="insurance-management-claims-buttons">
        </div>
      </div>
      <div class="section-content" style="display: flex; flex-direction: column; height: 150px; overflow: auto" data-cy="insurance-management-claims-content">
        <div *ngIf="this.dataClaims.length === 0" data-cy="insurance-management-no-claims">
          No claims exist for this patient.
        </div>
        <div *ngIf="this.dataClaims.length" style="height: 100%" data-cy="insurance-management-claims-container">
          <div *ngIf="!isLoading" style="flex: 1; overflow: auto;" data-cy="insurance-management-claims-table-container">

            <tdo-table [dataSource]="dataClaims" [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false" data-cy="insurance-management-claims-table">

              <tdo-table-column displayName="Claim #" propertyName="TDOClaimNumber" isSortable="false" [rowTemplate]="claimNumber" data-cy="insurance-management-claim-number-column">
                <ng-template #claimNumber let-row>
                  <span data-cy="insurance-management-claim-number-{{row.index}}">{{ row.TDOClaimNumber }}</span>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Method" propertyName="enumClaimMethodID" isSortable="false" [rowTemplate]="method" data-cy="insurance-management-method-column">
                <ng-template #method let-row>
                  <span data-cy="insurance-management-method-{{row.index}}">
                    {{ row.enumClaimMethodID === ClaimMethodEnumADAForm ? 'ADA Form' : '' }}
                    {{ row.enumClaimMethodID === ClaimMethodEnumAPIDX ? 'API DX' : '' }}
                  </span>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Amount" propertyName="ClaimAmount" isSortable="false" [rowTemplate]="org" data-cy="insurance-management-amount-column">
                <ng-template #org let-row>
                  <span data-cy="insurance-management-amount-{{row.index}}">{{ row.ClaimAmount }}</span>
                </ng-template>
              </tdo-table-column>

              <tdo-table-column displayName="Created" propertyName="ClaimDate" isSortable="true" [rowTemplate]="createdOn" data-cy="insurance-management-created-column">
                <ng-template #createdOn let-row>
                  <div *ngIf="row.model.ClaimDate" data-cy="insurance-management-created-{{row.index}}">
                    {{ row.model.ClaimDate | date }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Closed" propertyName="ClosedDate" isSortable="true" [rowTemplate]="closedOn" data-cy="insurance-management-closed-column">
                <ng-template #closedOn let-row>
                  <div *ngIf="row.model.ClosedDate" data-cy="insurance-management-closed-{{row.index}}">
                    {{ row.model.ClosedDate | date }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Sent" propertyName="SentDate" isSortable="true" [rowTemplate]="sentOn" data-cy="insurance-management-sent-column">
                <ng-template #sentOn let-row>
                  <div *ngIf="row.model.SentDate" data-cy="insurance-management-sent-{{row.index}}">
                    {{ row.model.SentDate | date }}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Type" propertyName="ClaimType" isSortable="true" [rowTemplate]="claimType" data-cy="insurance-management-type-column">
                <ng-template #claimType let-row>
                  <div *ngIf="row.model.ClaimType" data-cy="insurance-management-type-{{row.index}}">{{ row.model.ClaimType }}</div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Location" propertyName="LocationName" isSortable="true" [rowTemplate]="locationName" data-cy="insurance-management-location-column">
                <ng-template #locationName let-row>
                  <div *ngIf="row.model.LocationName" data-cy="insurance-management-location-{{row.index}}">{{ row.model.LocationName }}</div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Status" propertyName="ClaimStatus" isSortable="true" [rowTemplate]="claimStatus" data-cy="insurance-management-status-column">
                <ng-template #claimStatus let-row>
                  <span data-cy="insurance-management-status-{{row.index}}">{{ row.model.ClaimStatus }}</span>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
